import { isRocketInstance } from '@/config/instanceProfile'

export type PartnerDetailTabId = 'overview' | 'indicacoes' | 'network' | 'deals' | 'finance'

const ALL_PARTNER_DETAIL_TABS: { id: PartnerDetailTabId; label: string }[] = [
  { id: 'overview', label: 'Contato' },
  { id: 'indicacoes', label: 'Indicações' },
  { id: 'network', label: 'Rede' },
  { id: 'deals', label: 'Negociações' },
  { id: 'finance', label: 'Financeiro' },
]

export const PARTNER_DETAIL_TABS = ALL_PARTNER_DETAIL_TABS.filter(
  (tab) => tab.id !== 'network' || isRocketInstance,
)

export const PARTNER_COMMISSION_MODE_LABEL = {
  RECORRENTE: 'Percentual recorrente',
  DUAS_MENSALIDADES: 'Indicador: 100% da 1ª parcela',
} as const

export const PARTNER_COMMISSION_MODE_OPTIONS = [
  {
    id: 'RECORRENTE',
    label: 'Percentual recorrente',
    hint: 'Para Agência/Plataforma: percentual cadastrado, normalmente entre 10% e 20%, pago todo mês enquanto o cliente estiver ativo.',
  },
  {
    id: 'DUAS_MENSALIDADES',
    label: 'Indicador: 100% da 1ª parcela',
    hint: 'Para indicador/RP: pagamento único de 100% da primeira parcela somente, sem recorrência mensal.',
  },
] as const
